import React from "react";
import { Input } from "../../components/ui/input";
import { Field, INPUT_CLS } from "./FormControls";

export const DERIVATIVES = ["OPTIONS", "FUTURES", "F&O"];

export function derivedQuantity(form) {
  if (form.lots === "" || form.lot_size === "") return null;
  const q = Number(form.lots) * Number(form.lot_size);
  return Number.isNaN(q) ? null : q;
}

export default function DerivativeFields({ form, set, lotHint, onLotSizeInput }) {
  const qty = derivedQuantity(form);
  return (
    <>
      <Field label="Lots">
        <Input data-testid="trade-lots" type="number" step="1" min="1" value={form.lots} onChange={(e) => set("lots", e.target.value)}
          placeholder="2" className={`${INPUT_CLS} num`} />
      </Field>
      <Field label="Lot Size">
        <div className="relative">
          <Input data-testid="trade-lot-size" type="number" step="1" min="1" value={form.lot_size}
            onChange={(e) => onLotSizeInput(e.target.value)}
            placeholder="e.g. 75 for NIFTY" className={`${INPUT_CLS} num pr-28`} />
          {lotHint && (
            <span data-testid="lot-size-hint" title={lotHint}
              className="absolute right-2 top-1/2 -translate-y-1/2 text-[9px] tracking-wider uppercase text-[#007AFF] truncate max-w-[110px]">
              {lotHint}
            </span>
          )}
        </div>
      </Field>
      <Field label="Quantity (Lots × Lot Size)">
        <div data-testid="trade-quantity-derived"
          className="h-10 flex items-center px-3 bg-[#08080A]/60 border border-dashed border-[#27272A] text-[#A1A1AA] rounded-sm num text-sm">
          {qty != null ? `${qty} contracts` : "—"}
        </div>
      </Field>
    </>
  );
}
